import './App.css';
import ClaimPage from './component/ClaimPage';
import LoginPage from './component/LoginPage';
import Tasks from './component/TasksList';
import TasksManager from './component/TasksManagerList';
import ClaimsListPage from './component/ClaimsListPage';
import TicketPage from './component/TicketPage';
import React, { Component } from 'react';
import Tickets from './component/Tickets';
import Settings from './component/Settings';
import TaskView from './component/TaskView';
import AppHeader from './component/AppHeader';
import MessageBox from './component/MessageBox';
import ErrorMsgPopup from './component/ErrorMsgPopup';
import { BrowserRouter, Switch, Route, Redirect } from 'react-router-dom';
import ClaimFormPage from './component/ClaimFormPage';
import NewTicketForm, { EditTicketForm } from './component/TicketFormPage';
import TaskForm, {
  EditTaskForm,
  PredefinedTaskForm,
} from './component/TaskForm';
import Contact from './component/Contact';
import BasicDocuments from './component/Documents';
import store from './store/store.js';
import ImportFlights from './component/Maintenance/ImportFlights';
import SingleImportSummary from './component/Maintenance/ImportFlights/SingleImportSummary';
import PermissionDenied from './component/PermissionDeniedPage';

const PrivateRoute = ({
  component: Component,
  path,
  roleCheckRequired = false,
  ...rest
}) => {
  const authorizationStore = store.getState().authorization;
  const authorized =
    authorizationStore.authToken &&
    (!roleCheckRequired || authorizationStore.role !== 'transfer_claims');

    // Redirecting user with role "transfer_claims" from fobidden '/' path
  if (path === '/' && authorizationStore.role === 'transfer_claims') {
    return (
      <Route
        {...rest}
        render={(props) => (
          <Redirect
            to={{
              pathname: '/claims',
              state: { from: props.location },
            }}
          />
        )}
      />
    );
  }

  return (
    <Route
      {...rest}
      render={(props) =>
        authorized ? (
          <Component {...props} />
        ) : roleCheckRequired ? (
          <PermissionDenied />
        ) : (
          <Redirect
            to={{
              pathname: '/login',
              state: { from: props.location },
            }}
          />
        )
      }
    />
  );
};

class App extends Component {
  render() {
    return (
      <div className="c-App">
        <MessageBox />
        <ErrorMsgPopup />
        <Switch>
          <Route path="/login" component={LoginPage} />
          <Route path="/">
            <div className="o-fill">
              <AppHeader />
              <Switch>
                <PrivateRoute path="/tickets" component={Tickets} />
                <PrivateRoute path="/ticket/new" component={NewTicketForm} />
                <PrivateRoute
                  path="/ticket/edit/:id"
                  component={EditTicketForm}
                />
                <PrivateRoute path="/ticket/:id" component={TicketPage} />
                <PrivateRoute path="/claims" component={ClaimsListPage} />
                <PrivateRoute
                  path="/claim/edit/:id"
                  component={ClaimFormPage}
                />
                <PrivateRoute
                  path="/claim/:id/contact/pax"
                  component={Contact}
                />
                <PrivateRoute
                  path="/claim/:id/contact/airline"
                  component={Contact}
                />
                <PrivateRoute
                  path="/claim/:id/documents"
                  component={BasicDocuments}
                />
                <PrivateRoute path="/claim/:id" component={ClaimPage} />
                <PrivateRoute
                  path="/task/edit"
                  roleCheckRequired
                  component={EditTaskForm}
                />
                <PrivateRoute
                  path="/task/new-predefined"
                  roleCheckRequired
                  component={PredefinedTaskForm}
                />
                <PrivateRoute
                  path="/task/new"
                  roleCheckRequired
                  component={TaskForm}
                />
                <PrivateRoute
                  path="/task/:id"
                  roleCheckRequired
                  component={TaskView}
                />
                <PrivateRoute
                  path="/settings"
                  component={Settings}
                />
                <PrivateRoute
                  roleCheckRequired
                  path="/maintenance/flight-schedules-import/:id"
                  component={SingleImportSummary}
                />
                <PrivateRoute
                  roleCheckRequired
                  exact
                  path="/maintenance/flight-schedules-import/new"
                  component={ImportFlights}
                />
                <PrivateRoute
                  roleCheckRequired
                  exact
                  path="/maintenance/flight-schedules-import"
                  component={ImportFlights}
                />
                <PrivateRoute
                  roleCheckRequired
                  path="/manager-tasks"
                  component={TasksManager}
                  exact
                />
                <PrivateRoute path="/" roleCheckRequired component={Tasks} />
              </Switch>
            </div>
          </Route>
        </Switch>
      </div>
    );
  }
}

function routeredApp(WrappedComponent) {
  return (props) => (
    <BrowserRouter>
      <WrappedComponent {...props} />
    </BrowserRouter>
  );
}

App = routeredApp(App);

export default App;



// WEBPACK FOOTER //
// ./src/App.js